// 가장 가까운 스크롤 가능한 조상 안에서만 대상을 가운데로 스크롤한다.
// scrollIntoView 는 페이지 전체(헤더 포함)까지 밀어 올리므로 쓰지 않는다.
const isScrollable = el => {
  const { overflowY, overflowX } = window.getComputedStyle(el);
  const y = /(auto|scroll|overlay)/.test(overflowY) && el.scrollHeight > el.clientHeight;
  const x = /(auto|scroll|overlay)/.test(overflowX) && el.scrollWidth > el.clientWidth;
  return y || x;
};

export const scrollToCard = target => {
  if (!target) return;
  let parent = target.parentElement;
  while (parent && parent !== document.body && parent !== document.documentElement) {
    if (isScrollable(parent)) break;
    parent = parent.parentElement;
  }
  // 스크롤 컨테이너가 없으면 최소 이동만 하도록 nearest 로 맡긴다
  if (!parent || parent === document.body || parent === document.documentElement) {
    target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    return;
  }
  const box = parent.getBoundingClientRect();
  const rect = target.getBoundingClientRect();
  parent.scrollTo({
    top: parent.scrollTop + (rect.top - box.top) - (box.height - rect.height) / 2,
    left: parent.scrollLeft + (rect.left - box.left) - (box.width - rect.width) / 2,
    behavior: 'smooth',
  });
};
